import { useEffect, useRef, useState } from "react";

/**
 * Watches the screen wrapper's own width (a ResizeObserver on the frame, NOT the
 * viewport — the rail and browser chrome mean viewport width is not what the
 * table actually gets). Below `breakpoint` the detail panel should overlay the
 * list instead of displacing it (layout floor rule 2).
 */
export function useScreenOverlay(breakpoint = 1200) {
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const [overlay, setOverlay] = useState(false);

  useEffect(() => {
    const el = wrapperRef.current;
    if (!el || typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver((entries) => {
      const width = entries[0]?.contentRect.width ?? el.clientWidth;
      setOverlay(width < breakpoint);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [breakpoint]);

  return { wrapperRef, overlay };
}
